import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=23bada50"
import script from "./brand.js?vue&type=script&lang=js&external"
export * from "./brand.js?vue&type=script&lang=js&external"
import style0 from "./brand.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports